import { useEffect } from "react";

const SITE_NAME = "Pompes Funèbres Lumière des Nations";

/**
 * Updates the document title and meta description for each page.
 * Lightweight alternative to react-helmet for simple SEO needs.
 */
export default function usePageMeta(title, description) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Baho (66540) · 24h/24`;
    document.title = fullTitle;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [title, description]);
}
